"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RO = void 0;
exports.RO = {
    numericCode: '642',
    alpha2Code: 'RO',
    alpha3Code: 'ROU',
    englishName: {
        short: 'Romania',
        full: 'Romania',
    },
    names: {
        full: {
            en: 'Romania',
            fr: 'Roumanie (la)',
            ro: 'România',
        },
        short: {
            en: 'Romania',
            fr: 'Roumanie (la)',
            ro: 'România',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ro',
            languageAlpha3Code: 'ron',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'RO-AB': {
            numericCode: '642',
            code: 'RO-AB',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Alba',
            },
        },
        'RO-AG': {
            numericCode: '642',
            code: 'RO-AG',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Argeș',
            },
        },
        'RO-AR': {
            numericCode: '642',
            code: 'RO-AR',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Arad',
            },
        },
        'RO-BC': {
            numericCode: '642',
            code: 'RO-BC',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Bacău',
            },
        },
        'RO-BH': {
            numericCode: '642',
            code: 'RO-BH',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Bihor',
            },
        },
        'RO-BN': {
            numericCode: '642',
            code: 'RO-BN',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Bistrița-Năsăud',
            },
        },
        'RO-BR': {
            numericCode: '642',
            code: 'RO-BR',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Brăila',
            },
        },
        'RO-BT': {
            numericCode: '642',
            code: 'RO-BT',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Botoșani',
            },
        },
        'RO-BV': {
            numericCode: '642',
            code: 'RO-BV',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Brașov',
            },
        },
        'RO-BZ': {
            numericCode: '642',
            code: 'RO-BZ',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Buzău',
            },
        },
        'RO-CJ': {
            numericCode: '642',
            code: 'RO-CJ',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Cluj',
            },
        },
        'RO-CL': {
            numericCode: '642',
            code: 'RO-CL',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Călărași',
            },
        },
        'RO-CS': {
            numericCode: '642',
            code: 'RO-CS',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Caraș-Severin',
            },
        },
        'RO-CT': {
            numericCode: '642',
            code: 'RO-CT',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Constanța',
            },
        },
        'RO-CV': {
            numericCode: '642',
            code: 'RO-CV',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Covasna',
            },
        },
        'RO-DB': {
            numericCode: '642',
            code: 'RO-DB',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Dâmbovița',
            },
        },
        'RO-DJ': {
            numericCode: '642',
            code: 'RO-DJ',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Dolj',
            },
        },
        'RO-GJ': {
            numericCode: '642',
            code: 'RO-GJ',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Gorj',
            },
        },
        'RO-GL': {
            numericCode: '642',
            code: 'RO-GL',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Galați',
            },
        },
        'RO-GR': {
            numericCode: '642',
            code: 'RO-GR',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Giurgiu',
            },
        },
        'RO-HD': {
            numericCode: '642',
            code: 'RO-HD',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Hunedoara',
            },
        },
        'RO-HR': {
            numericCode: '642',
            code: 'RO-HR',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Harghita',
            },
        },
        'RO-IF': {
            numericCode: '642',
            code: 'RO-IF',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Ilfov',
            },
        },
        'RO-IL': {
            numericCode: '642',
            code: 'RO-IL',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Ialomița',
            },
        },
        'RO-IS': {
            numericCode: '642',
            code: 'RO-IS',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Iași',
            },
        },
        'RO-MH': {
            numericCode: '642',
            code: 'RO-MH',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Mehedinți',
            },
        },
        'RO-MM': {
            numericCode: '642',
            code: 'RO-MM',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Maramureș',
            },
        },
        'RO-MS': {
            numericCode: '642',
            code: 'RO-MS',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Mureș',
            },
        },
        'RO-NT': {
            numericCode: '642',
            code: 'RO-NT',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Neamț',
            },
        },
        'RO-OT': {
            numericCode: '642',
            code: 'RO-OT',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Olt',
            },
        },
        'RO-PH': {
            numericCode: '642',
            code: 'RO-PH',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Prahova',
            },
        },
        'RO-SB': {
            numericCode: '642',
            code: 'RO-SB',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Sibiu',
            },
        },
        'RO-SJ': {
            numericCode: '642',
            code: 'RO-SJ',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Sălaj',
            },
        },
        'RO-SM': {
            numericCode: '642',
            code: 'RO-SM',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Satu Mare',
            },
        },
        'RO-SV': {
            numericCode: '642',
            code: 'RO-SV',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Suceava',
            },
        },
        'RO-TL': {
            numericCode: '642',
            code: 'RO-TL',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Tulcea',
            },
        },
        'RO-TM': {
            numericCode: '642',
            code: 'RO-TM',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Timiș',
            },
        },
        'RO-TR': {
            numericCode: '642',
            code: 'RO-TR',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Teleorman',
            },
        },
        'RO-VL': {
            numericCode: '642',
            code: 'RO-VL',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Vâlcea',
            },
        },
        'RO-VN': {
            numericCode: '642',
            code: 'RO-VN',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Vrancea',
            },
        },
        'RO-VS': {
            numericCode: '642',
            code: 'RO-VS',
            category: {
                id: '296',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    ro: {
                        singular: 'judeţ',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'Vaslui',
            },
        },
        'RO-B': {
            numericCode: '642',
            code: 'RO-B',
            category: {
                id: '308',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'municipalité',
                        plural: '',
                    },
                    ro: {
                        singular: 'municipiu',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ro: 'București',
            },
        },
    },
    cities: [
        {
            name: 'Zimnicea',
            subdivision: 'Teleorman',
        },
        {
            name: 'Zărnești',
            subdivision: 'Braşov',
        },
        {
            name: 'Zalău',
            subdivision: 'Sălaj',
        },
        {
            name: 'Vulcan',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Voluntari',
            subdivision: 'Ilfov',
        },
        {
            name: 'Vişeu de Sus',
            subdivision: 'Maramureş',
        },
        {
            name: 'Vatra Dornei',
            subdivision: 'Suceava',
        },
        {
            name: 'Vaslui',
            subdivision: 'Vaslui',
        },
        {
            name: 'Urziceni',
            subdivision: 'Ialomiţa',
        },
        {
            name: 'Turnu Măgurele',
            subdivision: 'Teleorman',
        },
        {
            name: 'Turda',
            subdivision: 'Cluj',
        },
        {
            name: 'Tulcea',
            subdivision: 'Tulcea',
        },
        {
            name: 'Târnăveni',
            subdivision: 'Mureş',
        },
        {
            name: 'Târgu Secuiesc',
            subdivision: 'Covasna',
        },
        {
            name: 'Târgu Neamţ',
            subdivision: 'Neamţ',
        },
        {
            name: 'Târgu-Mureş',
            subdivision: 'Mureş',
        },
        {
            name: 'Târgu Jiu',
            subdivision: 'Gorj',
        },
        {
            name: 'Târgovişte',
            subdivision: 'Dâmboviţa',
        },
        {
            name: 'Timişoara',
            subdivision: 'Timiş',
        },
        {
            name: 'Tecuci',
            subdivision: 'Galaţi',
        },
        {
            name: 'Suceava',
            subdivision: 'Suceava',
        },
        {
            name: 'Slatina',
            subdivision: 'Olt',
        },
        {
            name: 'Şimleu Silvaniei',
            subdivision: 'Sălaj',
        },
        {
            name: 'Sighetu Marmaţiei',
            subdivision: 'Maramureş',
        },
        {
            name: 'Sibiu',
            subdivision: 'Sibiu',
        },
        {
            name: 'Sfântu-Gheorghe',
            subdivision: 'Covasna',
        },
        {
            name: 'Sebeş',
            subdivision: 'Alba',
        },
        {
            name: 'Satu Mare',
            subdivision: 'Satu Mare',
        },
        {
            name: 'Salonta',
            subdivision: 'Bihor',
        },
        {
            name: 'Săcele',
            subdivision: 'Braşov',
        },
        {
            name: 'Roșiorii de Vede',
            subdivision: 'Teleorman',
        },
        {
            name: 'Roman',
            subdivision: 'Neamţ',
        },
        {
            name: 'Râşnov',
            subdivision: 'Braşov',
        },
        {
            name: 'Râmnicu Vâlcea',
            subdivision: 'Vâlcea',
        },
        {
            name: 'Râmnicu Sărat',
            subdivision: 'Buzău',
        },
        {
            name: 'Reşiţa',
            subdivision: 'Caraş-Severin',
        },
        {
            name: 'Reghin-Sat',
            subdivision: 'Mureş',
        },
        {
            name: 'Rădăuți',
            subdivision: 'Suceava',
        },
        {
            name: 'Popeşti-Leordeni',
            subdivision: 'Ilfov',
        },
        {
            name: 'Ploieşti',
            subdivision: 'Prahova',
        },
        {
            name: 'Piteşti',
            subdivision: 'Argeş',
        },
        {
            name: 'Piatra Neamţ',
            subdivision: 'Neamţ',
        },
        {
            name: 'Petroşani',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Petrila',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Pantelimon',
            subdivision: 'Ilfov',
        },
        {
            name: 'Orăştie',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Oradea',
            subdivision: 'Bihor',
        },
        {
            name: 'Olteniţa',
            subdivision: 'Călăraşi',
        },
        {
            name: 'Odorheiu Secuiesc',
            subdivision: 'Harghita',
        },
        {
            name: 'Ocna Mureş',
            subdivision: 'Alba',
        },
        {
            name: 'Năvodari',
            subdivision: 'Constanța',
        },
        {
            name: 'Motru',
            subdivision: 'Gorj',
        },
        {
            name: 'Moreni',
            subdivision: 'Dâmboviţa',
        },
        {
            name: 'Moineşti',
            subdivision: 'Bacău',
        },
        {
            name: 'Mizil',
            subdivision: 'Prahova',
        },
        {
            name: 'Miercurea-Ciuc',
            subdivision: 'Harghita',
        },
        {
            name: 'Mediaş',
            subdivision: 'Sibiu',
        },
        {
            name: 'Medgidia',
            subdivision: 'Constanța',
        },
        {
            name: 'Mangalia',
            subdivision: 'Constanța',
        },
        {
            name: 'Lupeni',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Lugoj',
            subdivision: 'Timiş',
        },
        {
            name: 'Luduş',
            subdivision: 'Mureş',
        },
        {
            name: 'Iaşi',
            subdivision: 'Iaşi',
        },
        {
            name: 'Huşi',
            subdivision: 'Vaslui',
        },
        {
            name: 'Hunedoara',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Gura Humorului',
            subdivision: 'Suceava',
        },
        {
            name: 'Giurgiu',
            subdivision: 'Giurgiu',
        },
        {
            name: 'Gherla',
            subdivision: 'Cluj',
        },
        {
            name: 'Gheorgheni',
            subdivision: 'Harghita',
        },
        {
            name: 'Galaţi',
            subdivision: 'Galaţi',
        },
        {
            name: 'Găeşti',
            subdivision: 'Dâmboviţa',
        },
        {
            name: 'Focșani',
            subdivision: 'Vrancea',
        },
        {
            name: 'Filiaşi',
            subdivision: 'Dolj',
        },
        {
            name: 'Fetești-Gară',
            subdivision: 'Ialomiţa',
        },
        {
            name: 'Feteşti',
            subdivision: 'Ialomiţa',
        },
        {
            name: 'Fălticeni',
            subdivision: 'Suceava',
        },
        {
            name: 'Făgăraș',
            subdivision: 'Braşov',
        },
        {
            name: 'Drobeta-Turnu Severin',
            subdivision: 'Mehedinţi',
        },
        {
            name: 'Drăgăşani',
            subdivision: 'Vâlcea',
        },
        {
            name: 'Dorohoi',
            subdivision: 'Botoşani',
        },
        {
            name: 'Deva',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Dej',
            subdivision: 'Cluj',
        },
        {
            name: 'Curtea de Argeş',
            subdivision: 'Argeş',
        },
        {
            name: 'Cugir',
            subdivision: 'Alba',
        },
        {
            name: 'Craiova',
            subdivision: 'Dolj',
        },
        {
            name: 'Corabia',
            subdivision: 'Olt',
        },
        {
            name: 'Constanţa',
            subdivision: 'Constanța',
        },
        {
            name: 'Comăneşti',
            subdivision: 'Bacău',
        },
        {
            name: 'Codlea',
            subdivision: 'Braşov',
        },
        {
            name: 'Cluj-Napoca',
            subdivision: 'Cluj',
        },
        {
            name: 'Cisnădie',
            subdivision: 'Sibiu',
        },
        {
            name: 'Câmpulung Moldovenesc',
            subdivision: 'Suceava',
        },
        {
            name: 'Câmpina',
            subdivision: 'Prahova',
        },
        {
            name: 'Câmpia Turzii',
            subdivision: 'Cluj',
        },
        {
            name: 'Cernavodă',
            subdivision: 'Constanța',
        },
        {
            name: 'Carei',
            subdivision: 'Satu Mare',
        },
        {
            name: 'Caransebeş',
            subdivision: 'Caraş-Severin',
        },
        {
            name: 'Caracal',
            subdivision: 'Olt',
        },
        {
            name: 'Calafat',
            subdivision: 'Dolj',
        },
        {
            name: 'Buzău',
            subdivision: 'Buzău',
        },
        {
            name: 'Buhuşi',
            subdivision: 'Bacău',
        },
        {
            name: 'Buftea',
            subdivision: 'Ilfov',
        },
        {
            name: 'Bucharest',
            subdivision: 'Bucureşti',
        },
        {
            name: 'Breaza',
            subdivision: 'Prahova',
        },
        {
            name: 'Braşov',
            subdivision: 'Braşov',
        },
        {
            name: 'Brăila',
            subdivision: 'Brăila',
        },
        {
            name: 'Brad',
            subdivision: 'Hunedoara',
        },
        {
            name: 'Botoşani',
            subdivision: 'Botoşani',
        },
        {
            name: 'Borşa',
            subdivision: 'Maramureş',
        },
        {
            name: 'Bocşa',
            subdivision: 'Caraş-Severin',
        },
        {
            name: 'Blaj',
            subdivision: 'Alba',
        },
        {
            name: 'Bistriţa',
            subdivision: 'Bistriţa-Năsăud',
        },
        {
            name: 'Bârlad',
            subdivision: 'Vaslui',
        },
        {
            name: 'Balş',
            subdivision: 'Olt',
        },
        {
            name: 'Băileşti',
            subdivision: 'Dolj',
        },
        {
            name: 'Băicoi',
            subdivision: 'Prahova',
        },
        {
            name: 'Baia Sprie',
            subdivision: 'Maramureş',
        },
        {
            name: 'Baia Mare',
            subdivision: 'Maramureş',
        },
        {
            name: 'Bacău',
            subdivision: 'Bacău',
        },
        {
            name: 'Arad',
            subdivision: 'Arad',
        },
        {
            name: 'Alexandria',
            subdivision: 'Teleorman',
        },
        {
            name: 'Alba Iulia',
            subdivision: 'Alba',
        },
        {
            name: 'Aiud',
            subdivision: 'Alba',
        },
        {
            name: 'Adjud',
            subdivision: 'Vrancea',
        },
        {
            name: 'Baia Mare',
            subdivision: 'Satu Mare',
        },
        {
            name: 'Paşcani',
            subdivision: 'Iaşi',
        },
        {
            name: 'Mioveni',
            subdivision: 'Argeş',
        },
        {
            name: 'Sighișoara',
            subdivision: 'Mureş',
        },
        {
            name: 'Slobozia',
            subdivision: 'Ialomiţa',
        },
        {
            name: 'Sector 1',
            subdivision: 'Bucureşti',
        },
        {
            name: 'Sector 2',
            subdivision: 'Bucureşti',
        },
        {
            name: 'Sector 3',
            subdivision: 'Bucureşti',
        },
        {
            name: 'Sector 4',
            subdivision: 'Bucureşti',
        },
        {
            name: 'Sector 5',
            subdivision: 'Bucureşti',
        },
        {
            name: 'Sector 6',
            subdivision: 'Bucureşti',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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